var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"avatar-large",attrs:{"src":_vm.src ? _vm.src : _vm.$icons._Placeholder.Profile,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }